import {
  AppEnvironment,
  AppEnvironmentContext,
} from '../../contexts/appEnvironmentContext';
import { useOfficeContext } from '../../utils/addin/office';

type Props = {
  children: React.ReactNode;
};

const AppEnvironmentProvider: React.FC<Props> = ({ children }) => {
  const { officeHost } = useOfficeContext();
  return (
    <AppEnvironmentContext.Provider
      value={{
        // If officeHost is defined, we are in an Office Add-in, otherwise we are in a web app
        appEnvironment: officeHost ? AppEnvironment.Office : AppEnvironment.Web,
      }}
    >
      {children}
    </AppEnvironmentContext.Provider>
  );
};

export default AppEnvironmentProvider;
